import React from "react";
import { congratulation } from "../Constant/Index";
import { Link } from "react-router-dom";

const MyModal = ({ show, handleClose }) => {
	return (
		<div
			className={`modal fade ${show ? "show" : ""}`}
			style={{ display: show ? "block" : "none" }}
			tabIndex="-1"
			aria-labelledby="exampleModalLabel"
			aria-hidden={!show}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header border-bottom-none">
						<button
							type="button"
							className="btn-close"
							onClick={handleClose}
							aria-label="Close"
						></button>
					</div>
					<div className="modal-body border-bottom-none text-center">
						<div className="">
							<img src={congratulation} className="img-fluid" alt="" />
							<h3 className="main-heading-font dark-color level-3  mb-4">
								Congratulations!
							</h3>
							<h6 className="extra-color-6 primary-regular-font mb-3 mt-2 level-7">
								Your appointment with Dr. David Patel is confirmed for June 30,
								2023, at 10:00 AM.
							</h6>
							<div className="row">
								<div className="col-lg-12">
									<Link
										className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration- mt-2"
										href="/book-appointment"
									>
										<span className="bg-wrapper w-100">Done</span>
									</Link>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer border-top-none"></div>
				</div>
			</div>
		</div>
	);
};

export default MyModal;
